import { render, staticRenderFns } from "./companyMaterials.vue?vue&type=template&id=9a468bd2&scoped=true&"
import script from "./companyMaterials.vue?vue&type=script&lang=js&"
export * from "./companyMaterials.vue?vue&type=script&lang=js&"
import style0 from "./companyMaterials.vue?vue&type=style&index=0&id=9a468bd2&prod&lang=scss&scoped=true&"
import style1 from "./companyMaterials.vue?vue&type=style&index=1&id=9a468bd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a468bd2",
  null
  
)

export default component.exports